export default class NewsSelectPicker {
    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind(){
        this.$view.find('#category').on('change', function(e){
            var $form = $(e.target).closest("form");
            $form.submit();
        });
    }


}